import React from "react";
import { SimpleGrid, Box, Flex } from "@chakra-ui/react";
import { PricingCard } from "./card";
import { pricingPlans } from "./data";

const cardGap = { base: "big", lg: "small" };

export function PricingPlans() {
  return (
    <Flex
      flexDir="column"
      gap={cardGap}
      maxW={{ base: "600px", lg: "100%" }}
      mx="auto"
      mt={{ base: "bigger", md: "biggest", lg: "huge" }}
    >
      <SimpleGrid columns={{ base: 1, lg: 2 }} alignItems="stretch" gap={cardGap} justifyContent="center" w="100%">
        <PricingCard {...pricingPlans["ai-decisioning"]} order={{ base: 2, lg: 1 }} />
        <PricingCard {...pricingPlans["composable-cdp"]} order={{ base: 1, lg: 2 }} />
      </SimpleGrid>
      <Box>
        <PricingCard {...pricingPlans["reverse-etl"]} />
      </Box>
    </Flex>
  );
}
